import * as styles from "./Toggle.css";

import { clsx } from "clsx";
import type { JSX } from "react";

import { Toggle as BaseToggle } from "@base-ui/react/toggle";
import { useToggleGroupContext } from "@frontend/components/atoms/ToggleGroup";
import { useControlContext } from "@frontend/contexts";

import type { ToggleProps } from "./Toggle.types";

export function Toggle({
  size,
  variant,
  className,
  ...props
}: ToggleProps): JSX.Element {
  const group = useToggleGroupContext();
  const inherited = useControlContext();
  const resolvedSize = size ?? inherited.size;

  return (
    <BaseToggle
      data-slot="toggle"
      className={clsx(
        styles.toggle({
          size: resolvedSize,
          variant,
          orientation: group?.orientation,
          groupVariant: group?.variant,
        }),
        className,
      )}
      {...props}
    />
  );
}
